import { Box, LinearProgress, Typography } from "@mui/material"


export const LinearProgressDownload = ({show,text}:{show:boolean,text:string}) => {
   

    return (<>
        {show && (
            <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                <Typography sx={{fontSize:'12px',textAlign:'center'}}>{text}</Typography>
                <LinearProgress sx={{minWidth:'100px'}}/>
            </Box>
        )}
        
    </>)
}